import React, { useState } from "react";
import ReactPlayer from 'react-player/youtube';

const Video = (props) => {
    const { width, height, url, playing, loop, controls, muted, light } = props;
    
    return (
        <ReactPlayer
            width={width}
            height={height}
            playing={playing}
            url={url}
            loop={loop}
            controls={controls}
            muted={muted}
            light={light}
        />
    );
};

export default Video;
